// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"152":"af6cdd43ed5f82c1","2888":"eed86b9fd407e437"}[chunkId] + ".css";
};